import {Component, HostBinding, Input} from '@angular/core';
import {MatIconModule} from "@angular/material/icon";

/** "Pill" display of a transcription's state */
@Component({
	selector: 'app-tasks-pill',
	imports: [
		MatIconModule
	],
	templateUrl: './appointment-tasks-pill.html',
	standalone: true,
	styleUrl: './appointment-tasks-pill.scss'
})
export class AppointmentTasksPillComponent {
	/** Class to set for the component */
	@HostBinding("class")
	class:string;

	/** Text for the pill */
	private _text:string;

	/** Text for the pill */
	@Input()
	set text(value:string) {
		this._text = value;
	}

	get text():string {
		return this._text;
	}

	/** TThe current state of the tasks */
	@Input()
	set className(className:string) {
		this.class = className;
	}

	get isDone() {
		return (this.class??'').startsWith("done");
	}
}
